import React, { useState, useEffect, useRef } from "react";
import { Map, GoogleApiWrapper, Marker } from "google-maps-react";
import { Flex } from "antd";

const GoogleMap = ({ google, clickedLocation, setClickedLocation }) => {
  const mapRef = useRef(null);
  const [mapContainerStyle, setMapContainerStyle] = useState({
    height: "100vh",
    maxWidth: "500px",
  });

  const handleMapClick = (mapProps, map, clickEvent) => {
    const { latLng } = clickEvent;
    const lat = latLng.lat();
    const lng = latLng.lng();
    setClickedLocation({ lat, lng });
  };

  const handleMarkerClick = (markerProps, marker, clickEvent) => {
    console.log("Marker clicked");
  };

  const [initialCenter, setInitialCenter] = useState(null);
  const [loadingLocation, setLoadingLocation] = useState(false);

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setInitialCenter({ lat: latitude, lng: longitude });
          setLoadingLocation(false);
        },
        (error) => {
          console.error("Error getting user's location:", error);
          setLoadingLocation(false);
        }
      );
    } else {
      console.error("Geolocation not supported by the browser");
      setLoadingLocation(false);
    }

    return () => { };
  }, []);

  useEffect(() => {
    if (clickedLocation && mapRef.current) {
      const map = mapRef.current.map;
      const markerLocation = new google.maps.LatLng(
        clickedLocation.lat,
        clickedLocation.lng
      );

      map.panTo(markerLocation);
      map.setZoom(17);
    }
  }, [clickedLocation, google]);

  return (
    <Flex style={{ height: "100vh", width: "100%" }}>
      {loadingLocation ? (
        <div>Loading...</div>
      ) : (
        <Map
          ref={mapRef}
          google={google}
          zoom={17}
          initialCenter={initialCenter || { lat: 0, lng: 0 }}
          onClick={handleMapClick}
          style={mapContainerStyle}
          containerStyle={mapContainerStyle}
        >
          {clickedLocation && (
            <Marker
              position={clickedLocation}
              onClick={handleMarkerClick}
              animation={google.maps.Animation.DROP}
            />
          )}
        </Map>
      )}
    </Flex>
  );
};

const WrappedMap = GoogleApiWrapper({
  apiKey: "AIzaSyCtGbNuWZq40kaL5WQBKorp-hk261TkYWs",
})(GoogleMap);

export default WrappedMap;

